<template>
  <div class="row">
    <div v-if="requiereIngresarLaContrasenaActual" class="form-group col-md-12">
      <label for="contrasena">Ingrese la contraseña actual</label>
      <input id="contrasena" class="form-control" type="password" v-model="contrasena" placeholder="Contraseña actual" />
    </div>
    <div class="col-md-12">
      <ul class="col-md-12">
        <li>
          <i v-if="tipoDeFuerza.letraMinuscula == true" class="fas fa-check-circle verdeFuerte"></i>
          <i v-else class="fas fa-times-circle rojo"></i>
          &nbsp;&nbsp;Es requerido mínimo una letra minúscula.
        </li>
        <li>
          <i v-if="tipoDeFuerza.letraMayuscula == true" class="fas fa-check-circle verdeFuerte"></i>
          <i v-else class="fas fa-times-circle rojo"></i>
          &nbsp;&nbsp;Es requerido mínimo una letra mayúscula.
        </li>
        <li>
          <i v-if="tipoDeFuerza.numero == true" class="fas fa-check-circle verdeFuerte"></i>
          <i v-else class="fas fa-times-circle rojo"></i>
          &nbsp;&nbsp;Es requerido mínimo un numero.
        </li>
        <li>
          <i v-if="tipoDeFuerza.caracterEspecial == true" class="fas fa-check-circle verdeFuerte"></i>
          <i v-else class="fas fa-times-circle rojo"></i>
          &nbsp;&nbsp;Es requerido mínimo un carácter especial.
        </li>
        <li>
          <i v-if="tipoDeFuerza.cantidadDeLetras == true" class="fas fa-check-circle verdeFuerte"></i>
          <i v-else class="fas fa-times-circle rojo"></i>
          &nbsp;&nbsp;Es requerido un mínimo de 8 letras.
        </li>
      </ul>
    </div>
    <div class="form-group col-md-12">
      <label for="nuevacontrasena">Ingrese la nueva contraseña</label>
      <input id="nuevacontrasena" class="form-control" type="password" v-model="nuevaContrasena" placeholder="Nueva contraseña" v-on:keyup="validarLaFuerzaDeLaContrasena()" />
      <label :class="claseDeFuerza" v-html="nivelDeFuerza"></label>
    </div>
    <div class="form-group col-md-12">
      <label for="confirmenuevacontrasena">Confirme la nueva contraseña</label>
      <input id="confirmenuevacontrasena" class="form-control" type="password" v-model="confirmarNuevaContrasena" placeholder="Confirme la nueva contraseña" />
    </div>
    <div class="text-right col-md-12">
      <button class="btn btn-primary" v-on:click="guardarContrasena()">
        <i class="fa fa-save"></i>&nbsp;&nbsp;Guardar contraseña
      </button>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import router from '@/router/index'
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        enumeraciones,
        nivelDeFuerza: "",
        claseDeFuerza: "",
        contrasena: "",
        nuevaContrasena: "",
        confirmarNuevaContrasena: "",
        fuerza: 0,
        tipoDeFuerza: {
          letraMinuscula: false,
          letraMayuscula: false,
          numero: false,
          caracterEspecial: false,
          cantidadDeLetras: false
        }
      }
    },
    props: {
      requiereIngresarLaContrasenaActual: Boolean
    },
    methods: {
      validarLaFuerzaDeLaContrasena: function() {
        this.fuerza = 0;
  
        if (this.nuevaContrasena.match(/[a-z]+/)) {
          this.tipoDeFuerza.letraMinuscula = true;
          this.fuerza += 1;
        } else {
          this.tipoDeFuerza.letraMinuscula = false;
        }
        if (this.nuevaContrasena.match(/[A-Z]+/)) {
          this.tipoDeFuerza.letraMayuscula = true;
          this.fuerza += 1;
        } else {
          this.tipoDeFuerza.letraMayuscula = false;
        }
        if (this.nuevaContrasena.match(/[0-9]+/)) {
          this.tipoDeFuerza.numero = true;
          this.fuerza += 1;
        } else {
          this.tipoDeFuerza.numero = false;
        }
        if (this.nuevaContrasena.match(/[ ¡!"#$%&'()*+,-.:;<=>¿?@^_`{|}~\\/]+/)) {
          this.tipoDeFuerza.caracterEspecial = true;
          this.fuerza += 1;
        } else {
          this.tipoDeFuerza.caracterEspecial = false;
        }

        switch (this.fuerza) {
          case 0:
            this.claseDeFuerza = "nivelDeFuerza rojo";
            this.nivelDeFuerza = "";
            break;
          case 1:
            this.claseDeFuerza += "nivelDeFuerza rojo";
            this.nivelDeFuerza = "La contraseña es débil.";
            break;
          case 2:
            this.claseDeFuerza += "nivelDeFuerza amarillo";
            this.nivelDeFuerza = "La contraseña es buena.";
            break;
          case 3:
            this.claseDeFuerza += "nivelDeFuerza verde";
            this.nivelDeFuerza = "La contraseña es fuerte.";
            break;
          case 4:
            this.claseDeFuerza += "nivelDeFuerza verdeFuerte";
            this.nivelDeFuerza = "La contraseña es bastante fuerte.";
            break;
        }

        if (this.nuevaContrasena.length < 8) {
          this.tipoDeFuerza.cantidadDeLetras = false;
          if(this.nivelDeFuerza != "")
            this.nivelDeFuerza += "<br />";
          this.nivelDeFuerza += "El mínimo numero de caracteres permitido es 8.";
        } else {
          this.tipoDeFuerza.cantidadDeLetras = true;
        }
      },
      validarQueSeanIdenticasLasContrasenas: function () {
        if(this.fuerza < 4) {
          comun.mensajeDeAlerta("La contraseña no es lo suficientemente fuerte.<br/>Corrija los errores e inténtelo de nuevo.", null, null);
          return false;
        }
        if (this.nuevaContrasena.length < 8) {
          comun.mensajeDeAlerta("El mínimo numero de caracteres permitido es 8.<br/>Corrija el error e inténtelo de nuevo.", null, null);
          return false;
        }
        if(this.nuevaContrasena !== this.confirmarNuevaContrasena) {
          comun.mensajeDeAlerta("Las contraseñas ingresadas no son las mismas.<br/>Corrija el error e inténtelo de nuevo.", null, null);
          return false;
        }

        return true;
      },
      guardarContrasena: function() {
        if(this.validarQueSeanIdenticasLasContrasenas()) {
          comun.SeEstaCargandoInformacion(true);
  
          let parametros = {
            Contrasena: this.nuevaContrasena,
            EsPrueba: this.enumeraciones.EsPrueba
          };

          if(this.requiereIngresarLaContrasenaActual)
            parametros.ContrasenaActual = this.contrasena;
    
          axios.post(
            api.conexion + api.Cuentas.funcion.CambiarContrasena,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
              if(respuesta.data.SiHayError) {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } else {
                this.contrasena = "";
                this.nuevaContrasena = "";
                this.confirmarNuevaContrasena = "";
                this.claseDeFuerza = "nivelDeFuerza rojo";
                this.nivelDeFuerza = "";
                this.fuerza = 0;
    
                if(this.requiereIngresarLaContrasenaActual)
                  this.recargarDatosDeLaSesion(respuesta.data.Satisfactorio);
                else
                  this.cerrarSesion(respuesta.data.Satisfactorio);
              }

              comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
            });
        }
      },
      recargarDatosDeLaSesion: async function(mensaje) {
        comun.mensajeDeAlerta(mensaje, null, null)
        const parametros = {
          CargaInformacionDePaginaActual: true
        }

        await this.A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema(parametros);
      },
      cerrarSesion: function(mensaje) {
        localStorage.removeItem('Authorization');
        comun.mensajeDeAlerta(mensaje + "<br />La sesión ha sido finalizada por el cambio de contraseña.<br />Inicie sesión de nuevo para continuar con sus actividades.", null, null)
    
        router.push({ path: "/Login" });
      },
      ...mapActions([
        'A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema'
      ])
    }
  }
</script>


<style scoped>
  .rojo {
    color: red;
  }

  .amarillo {
    color: yellow;
  }

  .verde {
    color: lime;
  }

  .verdeFuerte {
    color: darkgreen;
  }

  .nivelDeFuerza {
    padding-top: 3px;
    padding-bottom: 3px;
  }

  ul {
        padding-left: 0;
    }

    li {
        list-style-type: none;
    }

    .btn-primary {
      background-color: var(--verde-pj-100);
    }
</style>



// WEBPACK FOOTER //
// src/components/Cuentas/Comun/Contrasena/NuevaContrasena.vue